export const BUILDER_FORM_CONFIG = {
  formType: 'builder',
  kicker: 'Builders & developers',
  title: 'Build with us',
  titleAccent: '',
  lede: 'Tell us about your project — models, framing system integration, or partnership in your market.',
  featured: true,
  pageTitle: 'Build with us — Construx',
  successTitle: 'Thank you',
  successMessage:
    'Your information has been submitted. We appreciate your interest, and one of our representatives will be in touch within one business day.',
};

export const INVESTOR_FORM_CONFIG = {
  formType: 'investor',
  kicker: 'Investors',
  title: 'Invest in us',
  titleAccent: '',
  lede: 'Share a bit about your firm and interest in Construx — we’ll follow up with the right materials.',
  featured: false,
  pageTitle: 'Invest in us — Construx',
  successTitle: 'Thank you',
  successMessage:
    'Your information has been submitted. We appreciate your interest, and one of our representatives will be in touch within one business day.',
};
